import i18n from '../../i18n';

function getLocale(): string {
  return i18n.language === 'ar' ? 'ar-SA' : 'en-SA';
}

export function formatDistanceToNow(dateStr: string): string {
  const date = new Date(dateStr);
  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffSecs = Math.floor(diffMs / 1000);
  const diffMins = Math.floor(diffSecs / 60);
  const diffHours = Math.floor(diffMins / 60);
  const diffDays = Math.floor(diffHours / 24);
  const locale = getLocale();

  if (diffSecs < 60) return i18n.language === 'ar' ? 'الآن' : 'just now';
  if (diffMins < 60) return i18n.language === 'ar' ? `منذ ${diffMins} د` : `${diffMins}m ago`;
  if (diffHours < 24) return i18n.language === 'ar' ? `منذ ${diffHours} س` : `${diffHours}h ago`;
  if (diffDays === 1) return i18n.language === 'ar' ? 'أمس' : 'yesterday';
  if (diffDays < 7) return i18n.language === 'ar' ? `منذ ${diffDays} أيام` : `${diffDays}d ago`;
  return date.toLocaleDateString(locale, { month: 'short', day: 'numeric' });
}

export function formatDate(dateStr: string): string {
  if (!dateStr) return '';
  return new Date(dateStr).toLocaleDateString(getLocale(), {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

export function formatDateTime(dateStr: string): string {
  if (!dateStr) return '';
  return new Date(dateStr).toLocaleString(getLocale(), {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatNumber(value: number, decimals = 2): string {
  const locale = getLocale();
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(value);
}

export function formatCurrency(value: number, currency = 'SAR'): string {
  const locale = getLocale();
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
}
